import { Box, IconButton, Paper, Stack, styled } from '@ethings/ui-toolkit';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Dialog, Slide, Tab } from '@mui/material';
import React, { FC, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { T_ONE } from '../../constants';
import { BottomNavigation } from '../bottom-navigation';
import { Icon } from '../icons';

export enum EventDialogTabs {
  EVENT = 'event',
  MEDIA = 'media',
}

interface Props {
  actions: JSX.Element[];
  closeDialog: () => void;
  'data-testid'?: string;
  eventData: JSX.Element;
  handleTabChange: (event: React.SyntheticEvent, value: EventDialogTabs) => void;
  mediaComponent?: JSX.Element;
  open: boolean;
  pageTitle: JSX.Element;
  selectedTab: EventDialogTabs;
}

const StyledPaper = styled(Paper)({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
});

export const EventDialogMobile: FC<Props> = ({
  actions,
  closeDialog,
  eventData,
  handleTabChange,
  mediaComponent,
  open,
  pageTitle,
  selectedTab,
  ...props
}) => {
  const { t } = useTranslation(['common']);

  return (
    <Dialog data-testid={props['data-testid']} fullScreen onClose={closeDialog} open={open}>
      <Box textAlign="right">
        <IconButton aria-label="close" onClick={closeDialog}>
          <Icon icon="X" />
        </IconButton>
      </Box>
      <Stack direction="row" padding={2} justifyContent="space-between" alignItems="center">
        {pageTitle}
      </Stack>
      <TabContext value={selectedTab}>
        {mediaComponent && (
          <TabList onChange={handleTabChange} variant="fullWidth" sx={{ minHeight: 64 }}>
            <Tab label={t('common:terms.event', { count: T_ONE })} value={EventDialogTabs.EVENT} />
            <Tab label={t('common:features.media')} value={EventDialogTabs.MEDIA} />
          </TabList>
        )}
        <Slide direction="right" in={selectedTab === EventDialogTabs.EVENT} mountOnEnter unmountOnExit>
          <TabPanel sx={{ overflow: 'auto', mb: 6, p: 2.25 }} value={EventDialogTabs.EVENT}>
            {eventData}
          </TabPanel>
        </Slide>
        {mediaComponent && (
          <Slide direction="left" in={selectedTab === EventDialogTabs.MEDIA} mountOnEnter unmountOnExit>
            <TabPanel sx={{ overflow: 'auto', mb: 3 }} value={EventDialogTabs.MEDIA}>
              {mediaComponent}
            </TabPanel>
          </Slide>
        )}
      </TabContext>
      <StyledPaper>
        <BottomNavigation>
          {actions}
        </BottomNavigation>
      </StyledPaper>
    </Dialog>
  );
};
